import React from 'react'
import SettingsCustomersForm from '../components/setting/settingsCustomersForm'

const SettingsCustomers = () => {
    return (<SettingsCustomersForm />)
}

export default SettingsCustomers